(function () {
  const dd = document.querySelectorAll('.dropdown');

  /**
   * Handle active/inactive state
   */
  dd.forEach(dropdown => {
    const button = dropdown.querySelector('button');

    button.addEventListener('click', (e) => {
      e.stopPropagation();

      // close all other dropdowns
      dd.forEach(d => {
        if (d !== dropdown) d.classList.remove('is--active');
      });

      dropdown.classList.toggle('is--active');
    });
  });

  // close all dropdowns if clicked outside any dropdown element
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.dropdown')) {
      dd.forEach(d => d.classList.remove('is--active'));
    }
  });

  /**
   * Handle keyboard navigation
   */
  document.addEventListener('keydown', (event) => {
    const activeDropdown = document.querySelector('.dropdown.is--active');
    if (!activeDropdown) return;

    const items = activeDropdown.querySelectorAll('ul > li > a');
    if (!items.length) return;

    let index = Array.from(items).findIndex(item => item === document.activeElement);

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      index = (index + 1) % items.length;
      items[index].focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      index = (index - 1 + items.length) % items.length;
      items[index].focus();
    }
  });


  /**
   * Handle positioning when the menu is on the right side of the page
   * This prevents the menu from displaying outside the window edge
   */
  function isElementOnRightSide(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.left + rect.width / 2 > window.innerWidth / 2;
  }

  function updateDropdownClasses() {
    const dropdowns = document.querySelectorAll('.dropdown'); // Select all dropdown elements

    dropdowns.forEach((dropdown) => {
      if (isElementOnRightSide(dropdown)) {
        dropdown.classList.add('is--right');
      } else {
        dropdown.classList.remove('is--right');
      }
    });
  }

  updateDropdownClasses();
  window.addEventListener('resize', updateDropdownClasses);
})();